import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
import { format, parseISO } from 'date-fns';
export function cn(...inputs) {
    return twMerge(clsx(inputs));
}
export function formatDate(dateValue, dateType = 'exact') {
    try {
        if (dateType === 'exact') {
            return format(parseISO(dateValue), 'MMM d, yyyy');
        }
        return dateValue;
    }
    catch {
        return dateValue;
    }
}
export function generateId() {
    return crypto.randomUUID();
}
export function copyToClipboard(text) {
    return navigator.clipboard.writeText(text);
}
export function getEditUrl(projectId, editSecret) {
    return `${window.location.origin}/e/${projectId}/${editSecret}`;
}
export function getViewUrl(projectId, viewSecret) {
    return `${window.location.origin}/v/${projectId}/${viewSecret}`;
}
export function hexToRgb(hex) {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result
        ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16),
        }
        : null;
}
export function colorWithOpacity(hex, opacity) {
    const rgb = hexToRgb(hex);
    if (!rgb)
        return hex;
    return `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, ${opacity})`;
}
export function truncate(str, maxLen) {
    if (str.length <= maxLen)
        return str;
    return str.slice(0, maxLen - 1) + '…';
}
export function debounce(fn, ms) {
    let timer;
    return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => fn(...args), ms);
    };
}
